import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  hiring: Yup.array(),
  massHiring: Yup.array(),
  dna: Yup.array()
});
